import { toBoolean } from '../../helpers/forms/prettifyField';

export const MONTANT_FRAIS_PORT_MIN = 300;
export const FRAIS_PORT = 7.95;

export const GET_FRAIS_PORT = (
  totalPanier: number,
  livraisonHorsLycee: boolean
): number => {
  if (typeof livraisonHorsLycee !== 'boolean')
    livraisonHorsLycee = toBoolean(livraisonHorsLycee);
  if (
    livraisonHorsLycee &&
    totalPanier < MONTANT_FRAIS_PORT_MIN &&
    totalPanier !== 0
  )
    return FRAIS_PORT;
  return 0;
};
